<template>
    <article class="game-wrap relative">
        <!-- <div class="game-background max-width">
        </div> -->
        <div class="game-inner max-width py-3 px-3 sm:py-2 relative">
            <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-0">
                <GameSettingsButtonFast v-model="gameStore.goldenFlower.fast" />
                <GameSettingsButtonRule v-model="oVisible.isOpenRule" name="jisuzhajinhuaGame" />
                <GameSettingsButtonVocie
                    v-model="settingStore.inhouseGames.sound.on"
                    v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                    :saveAfterChange="true"
                ></GameSettingsButtonVocie>
            </GameSettingsDiceTabsWrapper>
            <!--
                ↑ 通用控制条 
                ↓ 游戏区 
            -->
            <section class="history-bar">
                <div class="first-line">
                    <button class="history-btn" @click="showHistoryList">
                        <IconSvgUse use="icon-statistic-3" size="18px" />
                        {{ $t('History') }}
                    </button>
                </div>
            </section>

            <section
                :ref="(el) => (oStageDom = el)"
                class="game-stage"
                :class="{}"
                :style="{
                    '--name-tag-width': sNameTagWidth,
                }"
            >
                <div class="ratio-box">
                    <img class="green-table" src="../img/green-table.webp" />
                    <!-- 局数提示：第X/5局 -->
                    <div class="round-pill">
                        {{ `第${roomTable.currentRound}/${5}局` }}
                    </div>
                    <div class="players">
                        <!-- 
                            ↑ 发牌荷官 
                            ↓ 线上的玩家 
                        -->
                        <div
                            v-for="(oRoommate, idx) of playerList"
                            :key="idx"
                            class="relative"
                            :class="{
                                [idx === 6 ? 'user-self' : 'adversary']: true,
                            }"
                        >
                            <onePlayer
                                ref="playerRef"
                                :atRight="idx < 6 && idx % 2 === 1"
                                :userInfo="oRoommate"
                                :gamerID="String(idx + 1)"
                                :gameWinner="pkWinner"
                                :gamersInPk="gamersInPk"
                                :isSelect="oVisible.showSelect"
                                :round-time="seconds.round"
                                :is-banker="roomTable.dealerID === oRoommate?.id"
                                :current-turn-player-id="roomTable.currentTurnPlayerID"
                                :msgInfo="msgList[idx]"
                                @view-card="viewCard"
                                @select-user="(val) => startPk(idx + 1, val)"
                            />
                        </div>
                        <!--
                            ↓ 显示游戏结果
                        -->
                        <!-- VS动画已移除 -->
                    </div>
                    <!-- 提示文字 -->
                    <div v-if="oVisible.showSelect" class="select-text whitespace-nowrap">
                        {{ $t('goldenFlower.selectUser') }}
                    </div>
                    <!-- 新增：等待及倒计时阶段都要显示提示 -->
                    <div
                        v-if="statusMessage"
                        class="info-wrap"
                        :class="{
                            'info-wrap--auto-stop': isStopStatusMessage,
                            'info-wrap--countdown': !isStopStatusMessage,
                        }"
                    >
                        <span>{{ statusMessage }}</span>
                        <LoadingDots v-if="timers.ready && !isStopStatusMessage" />
                    </div>
                </div>
            </section>
            <div class="w-full flex justify-center mt-4">
                <template v-if="showCancelButton">
                    <ButtonThe3DButton color="red" size="lg" @click="cancelAutoStart">
                        {{ $t('jisuzhajinhua.cancel') }}
                    </ButtonThe3DButton>
                </template>
                <template v-else-if="showStopButton">
                    <ButtonThe3DButton
                        :color="isStopDisabled ? 'gray' : 'red'"
                        size="lg"
                        :disabled="isStopDisabled"
                        @click="requestStopAfterRound"
                    >
                        {{ $t('jisuzhajinhua.stopGame') }}
                    </ButtonThe3DButton>
                </template>
            </div>

            <!--
                ↑ 游戏舞台，游戏区 
                | ================================================
                | ================================================
                | ================================================ 
                ↓ 下注面板，表单
            -->
            <section class="bottom-box">
                <!-- 已移除手动操作区：自动比牌无需底部按钮 -->
            </section>
        </div>
        <!-- ↓ 修改 dom 位置恐引发出错，改时要注意 -->
        <!-- 黑色蒙版已移除 -->
    </article>

    <!-- 
        ↑ 游戏区 
        =============================================
        ↓ 弹出窗口 
    -->
    <!-- ↓ 历史“列表” 窗口 -->
    <HistoryList v-model="oVisible.historyList"></HistoryList>
    <!-- ↓ 历史"详情" 窗口，在此监听 route 参数变化并打开 -->
    <CasinoHistoryModalGameDetali :gameDropValue="'goldenFlower'" />
    <!-- ↓ 基本玩法弹窗 -->
    <GameRulesModal
        v-model="oVisible.showGameRules"
        :current-round="roomTable.currentRound"
        @start-game="onStartCloseRules"
    />
    <!-- ↓ 匹配牌桌提示弹窗 -->
    <ModalTitle v-model="oVisible.showMatchingTable" :backdrop="true" :show-close-icon="false">
        <template #header>
            <span class="text-[24px] leading-10 text-white font-bold">
                {{ $t('jisuzhajinhua.tip') }}
            </span>
        </template>
        <div class="text-white text-center py-4">
            <p class="text-[16px] leading-6 mb-2">
                {{ $t('jisuzhajinhua.matchingTable') }}
            </p>
            <p class="text-[16px] leading-6">
                {{ $t('jisuzhajinhua.matchingTableDesc') }}
            </p>
        </div>
    </ModalTitle>
    <!-- ↓ 继续游戏弹窗 -->
    <ModalTitle
        v-model="oVisible.showContinueModal"
        :backdrop="true"
        :show-close-icon="true"
        container-class="continue-modal"
        :body-style="{ padding: '24px' }"
        @hide-model="closeContinueModal"
    >
        <template #header>
            <span class="continue-modal__title">{{ $t('jisuzhajinhua.continueGame') }}</span>
        </template>
        <div class="continue-modal__content">
            <label class="continue-modal__radio" @click="onToggleAutoStart">
                <img
                    class="continue-modal__radio-icon"
                    :src="autoRestartAfterRound ? radioActiveSrc : radioSrc"
                    alt="radio"
                />
                <span>{{ $t('jisuzhajinhua.autoRestartHint') }}</span>
            </label>
            <ButtonThe3DButton
                class="continue-modal__action"
                color="green"
                size="lg"
                full-width
                @click="onConfirmContinue"
            >
                {{ $t('jisuzhajinhua.continueGame') }}
            </ButtonThe3DButton>
        </div>
    </ModalTitle>
</template>

<script lang="ts" setup>
// @ts-ignore
import onePlayer from '../_components/player.vue';
// @ts-ignore
import HistoryList from '../_components/historyList.vue';
// @ts-ignore
import GameRulesModal from '../_components/GameRulesModal.vue';
// @ts-ignore
import ModalTitle from '@/components/Modal/Title.vue';
// @ts-ignore
import GameSettingsDiceTabsWrapper from '@/components/Casino/GameSettings/DiceTabsWrapper.vue';
// @ts-ignore
import GameSettingsButtonFast from '@/components/Casino/GameSettings/Button/Fast.vue';
// @ts-ignore
import GameSettingsButtonRule from '@/components/Casino/GameSettings/Button/Rule.vue';
// @ts-ignore
import GameSettingsButtonVocie from '@/components/Casino/GameSettings/Button/Vocie.vue';
// @ts-ignore
import IconSvgUse from '@/components/Icon/SvgUse.vue';
// @ts-ignore
import LoadingDots from '@/components/Loading/Dots.vue';
import CasinoHistoryModalGameDetali from '@/components/Casino/History/Modal/GameDetali/index.vue';
// --- ↑ 组件  ----------------
import GameGBM from '@/assets/mp3/game_general_bgm.mp3';
import musicLose from '@/assets/mp3/redPacket/lose.mp3';
import musicWin from '@/assets/mp3/redPacket/win.mp3';
import musicSending from '@/assets/mp3/redPacket/sending.mp3';
import musicCollecting from '@/assets/mp3/redPacket/collecting.mp3';
import radioActiveSrc from '../img/radio_active.png';
import radioSrc from '../img/radio.png';
// ---- ↑ 音乐区 --------------
import { toCloseLoading } from '@/layouts/gameCoat/ts/gameCoat';
import { rotateAndMapPlayers } from '../ts/goldenFlowerCommon';
import { aAllCards } from '../ts/cardsConstant';
import { defaultSeconds } from '../ts/constants';
import type { Player, ActionMsg } from '../ts/types';

const isDEV = import.meta.env.DEV_MODE;
const showTest = false;
const isMetaDev = import.meta.dev;
// Static data instead of stores
const currency = ref('USDT'); // Default currency

// Static game settings data
const gameStore = reactive({
    goldenFlower: {
        fast: false,
    },
});

// Static settings data
const settingStore = reactive({
    inhouseGames: {
        sound: {
            on: ref(true),
            music: ref(1),
        },
    },
});
// -------- ↑ store 等 --------------------------------------
const oRoute = useRoute();
const { t: $tFn, locale } = useNuxtApp().$i18n;

const mine = reactive({ id: undefined, seatIndex: undefined, tableId: undefined, raiseNum: 0.1 });
// 音乐列表
const oMusicLib = {
    bg: {
        src: GameGBM,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    win: { src: musicWin },
    lose: { src: musicLose },
    sending: { src: musicSending },
    collecting: { src: musicCollecting }, // 这顶似乎作用不大，
};

// Static music controller - no actual music playing
const oMusic = {
    toDestory: () => {},
};

// ----- ↑ 导入公共资源 ----------------------
// ----- ↓ 本地数据 ----------------------

const sNameTagWidth = '70px';
const oStageDom = ref(null);

// 是否跟到底
const isAuto = ref(true);

// 是否自动开始下一轮游戏（5轮结束后自动开始）
const isAutoStart = ref(false);
type AutoPhase = 'idle' | 'matching' | 'countdown' | 'running' | 'stopping';
const autoPhase = ref<AutoPhase>('idle');
const stopAfterCurrentRound = ref(false);
const showCancelButton = computed(
    () => isAutoStart.value && (autoPhase.value === 'matching' || autoPhase.value === 'countdown'),
);
const showStopButton = computed(
    () => isAutoStart.value && (autoPhase.value === 'running' || autoPhase.value === 'stopping'),
);
const isStopDisabled = computed(() => autoPhase.value === 'stopping');
const resetAutoModeState = () => {
    isAutoStart.value = false;
    autoPhase.value = 'idle';
    stopAfterCurrentRound.value = false;
};

// 元素可见性管理中心
const oVisible = reactive({
    isOpenRule: false,
    historyList: false, // 历史窗口
    resultVisible: false, // 游戏结果
    phase02: false, // 游戏结果窗口内部元素
    hallList: !!0,
    playerList: !!0,
    showBlackMask: false,
    showSelect: false,
    showRaiseOption: false, // 是否显示跟注选项
    showReult: false, // pk结果图片
    showWait: false,
    showGameRules: false, // 基本玩法弹窗
    showMatchingTable: false, // 匹配牌桌提示弹窗
    showContinueModal: false,
});

// 已移除下注表单（静态演示无此交互）
const playerRef = ref([]);

// ↓ 7个玩家（左3、右3、自己在底部）
const aGamerList = reactive<(undefined | Player)[]>([
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
]);

// 玩家操作消息（展示在玩家头像上面）
const msgList = reactive<ActionMsg[]>([
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
]);

// 当前桌信息
const roomTable = reactive({
    currentRound: 0,
    currentTurnPlayerID: 0,
    dealerID: 0,
    hallName: undefined,
    id: undefined,
    maxBet: '',
    minBet: '',
    // winner: {},
    poolAmount: '0',
});

// ↓ 保存游戏结果
const oGameResult = reactive({
    hasWon: null, // null 输赢结果不明，布尔表示输赢结果
    pk: [], // pk中的玩家
    winner: '',
    banner: 6, // 自己固定在第7位（索引6）
});

// ----- ↓ 定时器相关 ----------------------
type TimerKey = 'ready' | 'change' | 'round';
const timers = reactive({
    ready: null, // 游戏开始定时器
    change: null, // 换桌定时器
    round: null, // 回合定时器
    autoCall: null, // 跟到底（自动跟）
});
const seconds = reactive({
    ready: defaultSeconds.ready, // 游戏开始倒计时
    change: defaultSeconds.change, // 换桌倒计时
    round: defaultSeconds.round, // 玩家回合倒计时
});
const statusMessage = computed(() => {
    if (autoPhase.value === 'stopping') return $tFn('jisuzhajinhua.stopAfterCurrentRound');
    if (timers.ready) return $tFn('jisuzhajinhua.gameStarting', { second: seconds.ready });
    return '';
});
const isStopStatusMessage = computed(() => autoPhase.value === 'stopping');
const autoRestartAfterRound = ref(true);
const INITIAL_PLAYER_CHIPS = 100;

const READY_COUNTDOWN_SECONDS = 3; // 新增：倒计时秒数（固定 3 秒）
const WAITING_FOR_PLAYERS_MS = 1500; // 新增：等待提示持续时间（毫秒）
const MATCHING_DELAY_MS = 1500;
const isWaitingForPlayers = ref(false); // 新增：标记是否处于等待其他玩家阶段
let waitingTimer: ReturnType<typeof setTimeout> | null = null; // 新增：保存等待阶段的定时器引用

const clearTimer = (key: TimerKey) => {
    const timer = timers[key];
    if (timer) {
        clearInterval(timer);
        clearTimeout(timer);
        timers[key] = null;
        seconds[key] = defaultSeconds[key];
    }
};

const clearAllTimer = () => {
    Object.keys(timers).forEach((key: TimerKey) => {
        clearTimer(key as TimerKey); // 新增：逐个重置所有定时器
    });
    clearWaitingState(); // 新增：同步清理等待与倒计时状态
};
// ----- ↑ 定时器相关 ----------------------

const clearWaitingState = () => {
    // 新增：复位等待阶段状态
    if (waitingTimer) {
        // 新增：若存在等待定时器则清除
        clearTimeout(waitingTimer); // 新增：清除等待阶段定时器
        waitingTimer = null; // 新增：重置定时器引用
    }
    isWaitingForPlayers.value = false; // 新增：退出等待阶段
};

const startReadyCountdown = (onFinish?: () => void) => {
    // 新增：启动倒计时
    clearTimer('ready'); // 新增：重置旧的 ready 计时器
    seconds.ready = READY_COUNTDOWN_SECONDS; // 新增：设置倒计时初始秒数
    timers.ready = setInterval(() => {
        // 新增：每秒递减一次
        if (seconds.ready <= 1) {
            // 新增：倒计时结束判定
            clearTimer('ready'); // 新增：清除倒计时定时器
            onFinish?.(); // 新增：倒计时完成后执行回调
        } else {
            seconds.ready -= 1; // 新增：倒计时递减
        }
    }, 1000); // 新增：按秒运行
};

const scheduleStartNewGame = (force = false) => {
    if (!force && !isAutoStart.value) return;
    autoPhase.value = 'countdown';
    clearWaitingState(); // 复位等待状态
    clearTimer('ready'); // 重置 ready 计时器
    startReadyCountdown(() => {
        if (!force && !isAutoStart.value) return;
        startNewGame(force); // 倒计时完成后正式开始游戏
    });
};

/**
 * 旋转玩家数组，确保自己（isSelf=true）永远在数组最后一个位置
 * 其他玩家的顺序保持不变
 */
const playerList = computed(() => {
    const list = aGamerList.map((it) => {
        if (it?.id) return { ...it, isSelf: it.id === mine.id };
        return it;
    });
    return rotateAndMapPlayers(list);
});

const gamerNum = computed(() => aGamerList.filter((it) => it?.id)?.length);

// 玩家 PK 连线
const gamersInPk = computed(() => {
    const sTwoPlays = oGameResult.pk;
    sTwoPlays.sort((aa, bb) => {
        // ↓ 一定要设为升序
        return aa - bb;
    });
    const sResult = oGameResult.pk.join('');
    console.log(`sTwoPlays`, deepCopy(sTwoPlays), sResult);
    return sResult;
});

const pkWinner = computed(() => oGameResult.winner);

// 移除大厅与厅配置（静态演示不使用）

const hallName = computed(() => oRoute?.query?.name);
// ↓ 当前厅 id（room ID)
const roomId = computed(() => {
    const iVal = Number(oRoute?.params?.id);
    return iVal;
});

// ===================================================================================
//          ↑ 陈列数据
//          ↓ 一些方法
// ===================================================================================

const toggleRaiseOption = (val?: boolean) => {
    /* removed */
};

// -------- ↓ 按钮交互操作 -------------------------------
// 看牌
const viewCard = async () => {
    toggleRaiseOption(false);
    // const res = await EMIT_ZHAJINHUA_SEE({ currency: currency.value, frontID: new Date().getTime(), hallName: hallName.value, tableID: mine.tableId });
    // aGamerList[mine.seatIndex].cards = res.cards;
    // aGamerList[mine.seatIndex].cardType = res.cardType;
};

// 换桌
const changeTable = () => {};
const requestStopAfterRound = () => {
    if (autoPhase.value !== 'running' || stopAfterCurrentRound.value) return;
    stopAfterCurrentRound.value = true;
    autoPhase.value = 'stopping';
};
// -------- ↑ 按钮交互操作 -------------------------------

const initGameResult = () => {
    oGameResult.pk = [];
    oGameResult.hasWon = null;
    oGameResult.winner = null;
};

// 设置当前牌桌及玩家信息
const setInfo = (data: any = {}) => {
    const { seats = [] } = data || {};
    Object.keys(roomTable).forEach((key) => {
        roomTable[key] = data[key];
    });
    seats.forEach((it, idx) => {
        let res;
        if (it.player?.id) {
            const { inGame, cards = [] } = it.player;
            res = { ...it.player, cards: inGame ? (cards.length ? cards : [{}, {}, {}]) : cards };
        }
        aGamerList[idx] = res;
    });
    // Static mode - no store updates
    if (!mine.tableId) {
        const seatIndex = seats.findIndex((it) => it.player?.id === mine.id);
        mine.tableId = data.id;
        mine.seatIndex = seatIndex;
    }
};

/**
 * 报告用户已经加入房间，并提到相关数据 - 静态模式
 */
const fnJoinTheHall = async () => {
    // 静态模式 - 直接设置房间信息
    mine.tableId = roomId.value;
    mine.seatIndex = 6; // 玩家在最后一个位置（第7个）

    // 创建静态房间数据
    const staticTableInfo = {
        id: roomId.value,
        currentRound: 0,
        currentTurnPlayerID: 0,
        dealerID: 0,
        hallName: hallName.value,
        maxBet: '1000',
        minBet: '0.1',
        poolAmount: '0',
        seats: [
            { occupied: false, player_id: 0, position: 0, player: null },
            { occupied: false, player_id: 0, position: 1, player: null },
            { occupied: false, player_id: 0, position: 2, player: null },
            { occupied: false, player_id: 0, position: 3, player: null },
            { occupied: false, player_id: 0, position: 4, player: null },
            { occupied: false, player_id: 0, position: 5, player: null },
            {
                occupied: true,
                player_id: mine.id,
                position: 6,
                player: {
                    id: mine.id,
                    name: '玩家',
                    chips: '1000',
                    isWatchCards: false,
                    isShowCard: false,
                    cards: [],
                    cardType: -1,
                    totalBet: 0,
                    inGame: false,
                    isQuit: false,
                    isLose: false,
                    avatar: '',
                    lvl: 1,
                },
            },
        ],
    };

    console.log('静态模式 - 加入房间获取房间信息', staticTableInfo);
    setInfo(staticTableInfo);

    // 静态模式 - 模拟加入房间
    console.log('静态模式 - 玩家已加入房间', mine.tableId);
};

const showHistoryList = () => {
    oVisible.historyList = true;
};

// 初始化玩家的通用函数
const mockOne = (idx: number) => ({
    id: Math.floor(Math.random() * 1e9),
    name: `U-${idx + 1}`,
    cards: [],
    inGame: false,
    chips: INITIAL_PLAYER_CHIPS.toFixed(2),
    isWatchCards: false,
    isShowCard: false,
    cardType: -1,
    totalBet: 0,
    isQuit: false,
    isLose: false,
    avatar: '',
    lvl: 1,
});

// 初始化游戏玩家的通用逻辑
const initGamePlayers = () => {
    // 确保玩家自己在列表中
    if (!aGamerList[6]?.id) {
        aGamerList[6] = {
            id: mine.id,
            name: '玩家',
            cards: [],
            inGame: false,
            chips: INITIAL_PLAYER_CHIPS.toFixed(2),
            isWatchCards: false,
            isShowCard: false,
            cardType: -1,
            totalBet: 0,
            isQuit: false,
            isLose: false,
            avatar: '',
            lvl: 1,
        } as any;
    }

    // 收集除自己外已存在的对手座位
    const existingOppSeats: number[] = [];
    for (let i = 0; i < 6; i++) {
        if (aGamerList[i]?.id) existingOppSeats.push(i);
    }

    // 只保留前3个已存在对手
    const keepSeats = existingOppSeats.slice(0, 3);

    // 清空其他对手座位
    for (let i = 0; i < 6; i++) {
        if (!keepSeats.includes(i)) aGamerList[i] = undefined as any;
    }

    // 若不足3个，则从空位中补足
    let need = 3 - keepSeats.length;
    if (need > 0) {
        for (let i = 0; i < 6 && need > 0; i++) {
            if (!aGamerList[i]?.id) {
                aGamerList[i] = mockOne(i) as any;
                need--;
            }
        }
    }

    // 确保至少有3个AI玩家
    let aiCount = 0;
    for (let i = 0; i < 6; i++) {
        if (aGamerList[i]?.id && aGamerList[i].id !== mine.id) {
            aiCount++;
        }
    }

    // 如果AI玩家不足3个，强制添加
    if (aiCount < 3) {
        for (let i = 0; i < 6 && aiCount < 3; i++) {
            if (!aGamerList[i]?.id || aGamerList[i].id === mine.id) {
                aGamerList[i] = mockOne(i) as any;
                aiCount++;
            }
        }
    }
};

const clearOpponentSeats = () => {
    for (let i = 0; i < 6; i++) {
        aGamerList[i] = undefined as any; // 仅清空对手位置，保留自己（索引6）
    }
};

const getChipValue = (chips?: string | number) => {
    const val = Number(chips ?? 0);
    return Number.isFinite(val) ? val : 0;
};

const applyChipDelta = (idx: number, delta: number) => {
    const player = aGamerList[idx];
    if (!player?.id) return;
    const current = getChipValue(player.chips);
    const next = Math.max(current + delta, 0);
    aGamerList[idx] = {
        ...player,
        chips: next.toFixed(2),
    } as any;
};

// 开始游戏的通用逻辑
function startNewGame(force = false) {
    if (!force && !isAutoStart.value && !stopAfterCurrentRound.value) return;
    if (autoPhase.value !== 'stopping') {
        autoPhase.value = 'running';
    }
    // 初始化玩家
    initGamePlayers();

    // 开局并发牌
    fn_开局();
    fn_发牌();

    // 进入第1局，并指定一个非自己的玩家先手，如果没有则自己
    roomTable.currentRound = 1;
    const firstOpponent = aGamerList.find((it) => it?.id && it?.id !== mine.id);
    roomTable.currentTurnPlayerID = firstOpponent?.id || mine.id;

    // 2秒后开始第一局
    setTimeout(() => {
        revealCards();
    }, 2000);
}

const showMatchingThenStart = (force = false) => {
    oVisible.showMatchingTable = true;
    clearOpponentSeats();
    setTimeout(() => {
        oVisible.showMatchingTable = false;
        scheduleStartNewGame(force);
    }, MATCHING_DELAY_MS);
};

const onStartCloseRules = () => {
    // 关闭规则弹窗
    oVisible.showGameRules = false;

    // 启用自动开始模式
    isAutoStart.value = true;
    stopAfterCurrentRound.value = false;

    // 先展示匹配过程再开始
    showMatchingThenStart();
};
// 从基本玩法弹窗开始游戏（或点击"自动开始"按钮）
const onStartGameFromRules = () => {
    console.log('从基本玩法弹窗开始游戏');
    // 关闭规则弹窗（如果打开的话）
    oVisible.showGameRules = false;

    // 启用自动开始模式
    isAutoStart.value = true;
    stopAfterCurrentRound.value = false;

    showMatchingThenStart();
};

// 取消自动开始
const cancelAutoStart = () => {
    resetAutoModeState();
    clearWaitingState(); // 新增：取消等待阶段以免继续倒计时
    clearTimer('ready'); // 新增：停止倒计时，恢复原状
    oVisible.showContinueModal = true;
};

// 开始比牌
const startPk = async (i, user?: any) => {
    oVisible.showSelect = false;
    oGameResult.pk = [7, i];
    console.log('startPk', user);
    await Sleep(600);
    // 黑色蒙版已移除
    const idx = Math.random() > 0.5 ? 0 : 1;
    oGameResult.winner = gamersInPk.value[idx] || '';
    Sleep(500).then(() => {
        initGameResult();
        // 每轮结算筹码
        const baseBet = Number(roomTable.minBet || 0);
        const winner = aGamerList.find((it) => String(it?.id) === oGameResult.winner);
        if (winner) {
            const winnerMultiplier = CARD_PAYOUT_MULTIPLIER[winner.cardType] || 0;
            const winnerPayout = baseBet * winnerMultiplier;
            applyChipDelta(aGamerList.indexOf(winner), winnerPayout);
        }
    });
};

// 所有人参与比牌：展示所有人的结果，随机出一位赢家
const startAllPk = async () => {
    oVisible.showSelect = false;
    // 参与者：当前可见的所有玩家（含自己）
    const participants = playerList.value
        .map((p, i) => ({ p, id: i + 1, idx: i }))
        .filter(({ p }) => p?.id);
    if (!participants.length) return;
    // 保存参与者（用于失败图标显示），用1基索引
    oGameResult.pk = participants.map(({ id }) => id);

    // 直接计算胜利者，跳过VS动画
    let best = { score: -1, id: participants[0].id };
    for (const it of participants) {
        const ct = Number(playerList.value[it.idx]?.cardType ?? -1);
        if (ct > best.score) {
            best = { score: ct, id: it.id };
        }
    }
    oGameResult.winner = String(best.id);

    const baseBet = Number(roomTable.minBet || 0);
    const multiplier = CARD_PAYOUT_MULTIPLIER[best.score] || 0;
    const payoutTotal = baseBet * multiplier;
    const losers = participants.filter(({ id }) => id !== best.id);
    if (payoutTotal > 0 && losers.length) {
        const lossPerLoser = payoutTotal / losers.length;
        for (const { idx } of losers) {
            applyChipDelta(idx, -lossPerLoser);
        }
        const winnerParticipant = participants.find(({ id }) => id === best.id);
        if (winnerParticipant) {
            applyChipDelta(winnerParticipant.idx, payoutTotal);
        }
    }

    // 显示胜利失败结果3秒钟（无黑色蒙版）
    await Sleep(3000);

    // 重置游戏结果
    initGameResult();

    // 重置所有玩家的看牌状态，为下一轮做准备
    for (const [idx, cur] of aGamerList.entries()) {
        if (!cur?.id) continue;
        aGamerList[idx] = {
            ...aGamerList[idx],
            isWatchCards: false,
            isShowCard: false,
            cardType: -1,
        } as any;
    }

    // 检查是否还有下一轮，若用户请求本局结束后停止则直接结算
    if (roomTable.currentRound < 5 && !stopAfterCurrentRound.value) {
        startNextRound();
    } else {
        endGame();
    }
};

const leave = async () => {
    const params = {
        currency: currency.value,
        frontID: new Date().getTime(),
        hallName: hallName.value,
        tableID: mine.tableId,
        // seatIndex: mine.seatIndex,
    };
    // ↓ 静态模式：无消息监听器
    // EMIT_ZHAJINHUA_LEAVE(params);
    // EMIT_ZHAJINHUA_EXIT({ currency: currency.value, tableID: mine.tableId, });
};

// -------- ↓ watch -------------------------------
// ↓ 为房间默认金额赋值
// watch(
//     () => oRoomConfig.value,
//     (oNewVal) => {
//         const todo = (
//             import.meta.client
//             && oNewVal.base
//             && !Number(oForm4Sending.amount) // 待赋值
//         );
//         console.log('todo', todo, oNewVal);
//         if (!todo) return;
//         const amount = Number(oNewVal.base).toFixed(2);
//         Object.assign(oForm4Sending, {
//             amount,
//         });
//     },
//     {immediate: true},
// );

// Static mode - no websocket connection watching

watch(
    () => isAuto.value,
    (nVal) => {
        if (!nVal) clearTimer(timers.autoCall);
    },
);
// ↓ 房间是否准备好开始进行游戏
// watch(aGamerList, () => {
//     const num = gamerNum.value;
//     const joinNum = aGamerList.filter(it => it?.id && it?.inGame).length;
//     console.log(`当前玩家数：${num}， 游戏中玩家数：${joinNum}`);
//     if (num <= 1) {
//         clearTimer('ready');
//     }
// });
/*  -------- ↑ watch -------------------------------  */

// 移除调试用的玩家进出方法

const fn_开局 = async () => {
    clearTimer('ready');
    for (const [idx, cur] of aGamerList.entries()) {
        aGamerList[idx] = {
            ...aGamerList[idx],
            cards: [],
            inGame: !!cur.id,
            isWatchCards: false, // 重置看牌状态
            isShowCard: false, // 重置亮牌状态
            cardType: -1, // 重置牌型
        };
    }
};

const fn_发牌 = async () => {
    console.log('开始发牌 - 发背面牌');
    // 第一步：先发背面（所有参与者）
    for (const [idx, cur] of aGamerList.entries()) {
        if (!cur?.id) continue;
        aGamerList[idx] = { ...aGamerList[idx], cards: gen3BackCards() } as any;
        await Promise.allSettled([nextTick()]);
    }
    // 第二步：在自动开牌时替换为正面（由 onStartGameFromRules 统一处理）
    console.log('发牌完成 - 背面牌已发', aGamerList);
};

// 生成3张可展示的牌：包含 suit 与 rank 字段
const gen3VisibleCards = () => {
    const picked = new Set<number>();
    const cards = [] as any[];
    while (cards.length < 3) {
        const idx = ~~(aAllCards.length * Math.random());
        if (picked.has(idx)) continue;
        picked.add(idx);
        const name = aAllCards[idx]; // e.g. 'spadesA'
        const suits = ['spades', 'hearts', 'diamonds', 'clubs'];
        const suit = suits.find((s) => name.startsWith(s)) || 'spades';
        const rank = name.slice(suit.length);
        cards.push({ suit, rank });
    }
    return cards;
};

// 生成3张背面牌（用于发牌阶段先发背面）
const gen3BackCards = () => [
    { suit: '', rank: '' },
    { suit: '', rank: '' },
    { suit: '', rank: '' },
];

// 牌型枚举
const CARD_TYPES = {
    SINGLE: 0, // 单牌
    PAIR: 1, // 对子
    STRAIGHT: 2, // 顺子
    FLUSH: 3, // 同花
    STRAIGHT_FLUSH: 4, // 同花顺
    THREE_OF_A_KIND: 5, // 三条
} as const;

const CARD_PAYOUT_MULTIPLIER: Record<number, number> = {
    [CARD_TYPES.SINGLE]: 2,
    [CARD_TYPES.PAIR]: 4,
    [CARD_TYPES.STRAIGHT]: 6,
    [CARD_TYPES.FLUSH]: 10,
    [CARD_TYPES.STRAIGHT_FLUSH]: 20,
    [CARD_TYPES.THREE_OF_A_KIND]: 40,
};

// 牌面值映射表（优化：使用Map提高查找性能）
const RANK_VALUES = new Map([
    ['A', 14],
    ['K', 13],
    ['Q', 12],
    ['J', 11],
    ['10', 10],
    ['9', 9],
    ['8', 8],
    ['7', 7],
    ['6', 6],
    ['5', 5],
    ['4', 4],
    ['3', 3],
    ['2', 2],
]);

// 计算牌型：0-单牌 1-对子 2-顺子 3-同花 4-同花顺 5-三条
const calculateCardType = (cards: any[]): number => {
    // 输入验证
    if (!cards || cards.length !== 3) return CARD_TYPES.SINGLE;

    // 提取并排序牌面值
    const ranks = cards.map((card) => RANK_VALUES.get(card.rank) || 0).sort((a, b) => b - a);

    // 提取花色
    const suits = cards.map((card) => card.suit);

    // 检查同花（所有花色相同）
    const isFlush = suits.every((suit) => suit === suits[0]);

    // 检查顺子
    const isStraight = checkStraight(ranks);

    // 检查三条
    const isThreeOfAKind = ranks[0] === ranks[1] && ranks[1] === ranks[2];

    // 检查对子
    const isPair = ranks[0] === ranks[1] || ranks[1] === ranks[2] || ranks[0] === ranks[2];

    // 按优先级判断牌型
    if (isThreeOfAKind) return CARD_TYPES.THREE_OF_A_KIND;
    if (isFlush && isStraight) return CARD_TYPES.STRAIGHT_FLUSH;
    if (isFlush) return CARD_TYPES.FLUSH;
    if (isStraight) return CARD_TYPES.STRAIGHT;
    if (isPair) return CARD_TYPES.PAIR;
    return CARD_TYPES.SINGLE;
};

// 检查是否为顺子（优化：提取为独立函数）
const checkStraight = (ranks: number[]): boolean => {
    // 普通顺子：连续递减
    const normalStraight = ranks[0] - ranks[1] === 1 && ranks[1] - ranks[2] === 1;

    // 特殊顺子：A-3-2（A作为1使用）
    const specialStraight = ranks[0] === 14 && ranks[1] === 3 && ranks[2] === 2;

    return normalStraight || specialStraight;
};

// 开始下一轮游戏
const startNextRound = () => {
    roomTable.currentRound++;
    console.log(`开始第${roomTable.currentRound}局`);

    // 1秒后开始发牌
    setTimeout(() => {
        dealCardsForRound();
    }, 1000);
};

// 发牌并开牌
const dealCardsForRound = () => {
    fn_开局();
    fn_发牌();

    // 2秒后自动开牌
    setTimeout(() => {
        revealCards();
    }, 2000);
};

// 开牌显示牌面
const revealCards = () => {
    console.log('自动开牌 - 开始翻牌');

    for (const [idx, cur] of aGamerList.entries()) {
        if (!cur?.id) continue;

        // 生成3张牌
        const cards = gen3VisibleCards();
        const cardType = calculateCardType(cards);

        console.log(`玩家 ${idx} 的牌:`, cards, '牌型:', cardType);

        aGamerList[idx] = {
            ...aGamerList[idx],
            isWatchCards: false,
            isShowCard: true,
            inGame: true,
            cards: cards,
            cardType: cardType,
        } as any;
    }

    // 0.6秒后显示牌型并开始比牌
    setTimeout(() => {
        showCardTypesAndStartPk();
    }, 600);
};

// 显示牌型并开始比牌
const showCardTypesAndStartPk = () => {
    console.log('开始显示牌型');

    // 显示所有玩家的牌型
    for (const [idx, cur] of aGamerList.entries()) {
        if (!cur?.id) continue;
        aGamerList[idx] = {
            ...aGamerList[idx],
            isWatchCards: true,
        } as any;
    }

    // 0.5秒后开始比牌
    setTimeout(() => {
        startAllPk();
    }, 500);
};

// 游戏结束
const endGame = () => {
    console.log('5局游戏结束');
    if (stopAfterCurrentRound.value) {
        resetAutoModeState();
        clearWaitingState();
        clearTimer('ready');
        console.log('自动开始模式：已根据用户操作停止');
        clearOpponentSeats();
        oVisible.showContinueModal = true;
        return;
    }

    // 重置游戏状态，准备下一轮
    roomTable.currentRound = 0;
    initGameResult();

    // 重置所有玩家的状态
    for (const [idx, cur] of aGamerList.entries()) {
        if (!cur?.id) continue;
        aGamerList[idx] = {
            ...aGamerList[idx],
            cards: [],
            inGame: false,
            isWatchCards: false,
            isShowCard: false,
            cardType: -1,
        } as any;
    }

    // 根据是否开启自动续局决定下一步
    if (isAutoStart.value && autoRestartAfterRound.value) {
        console.log('自动开始模式：准备开始下一轮5局游戏');
        showMatchingThenStart();
    } else {
        console.log('游戏结束，等待手动开始');
        autoPhase.value = 'idle';
        isAutoStart.value = false;
        clearOpponentSeats();
        oVisible.showContinueModal = true;
    }
};
const closeContinueModal = () => {
    oVisible.showContinueModal = false;
};
const onToggleAutoStart = () => {
    autoRestartAfterRound.value = !autoRestartAfterRound.value;
};
const onConfirmContinue = () => {
    oVisible.showContinueModal = false;
    stopAfterCurrentRound.value = false;
    const shouldAutoMatchNext = autoRestartAfterRound.value;
    isAutoStart.value = true; // 当前这一组仍以自动模式运行，保留取消/停止按钮
    showMatchingThenStart(!shouldAutoMatchNext);
};

// 移除未用的PK调试方法
/* 
----------------------------------------------------------
-------- ↓ 最下方，生命周期 ------------------------------- 
----------------------------------------------------------
*/

onMounted(async () => {
    // Static mode - use mock user ID
    mine.id = 12345; // Mock user ID
    toCloseLoading();
    console.log('jisuzhajinhua房间：开始进入 ▶️ 房间号：', oRoute?.params?.id, oRoute.query.name);
    console.log('当前路由信息：', oRoute);
    // Static mode - initialize with mock data
    fnJoinTheHall(); // 加入房间，同时查询配置信息等

    // 显示基本玩法弹窗
    setTimeout(() => {
        oVisible.showGameRules = true;
    }, 500); // 延迟500ms显示，确保页面加载完成
});

onBeforeUnmount(() => {
    console.log('房间：开始退出 ⏹️ 房间号：', oRoute?.params?.id, oRoute.query.name);
    // ↓ 退房声明（置于顶部使早执行）
    leave();
    oMusic.toDestory();
    resetAutoModeState();
    clearAllTimer();
    console.log('房间：退出完毕');
});
</script>

<style scoped src="./style/indoor.scss"></style>
<style scoped src="./style/game-bottom-part.scss"></style>
<style lang="scss" scoped>

.continue-modal__content {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.continue-modal__radio {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
}

.continue-modal__radio-icon {
    width: 20px;
    height: 20px;
}

.continue-modal__action {
    font-size: 16px;
    font-weight: 700;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes rotate1 {
    from {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(540deg);
    }
}
</style>
